import React, { useState, useEffect } from "react";
import { CircularProgress, Box, Modal } from "@mui/material";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import { useUserAdmin } from "../../../../admin/UserContext";

import { DiseñoFormUno } from "./FormDiseñoUno";
import { DiseñoFormDos } from "./FormDiseñoDos";
import { DiseñoFormTres } from "./FormDiseñoTres";
import { DiseñoFormCuatro } from "./FormDiseñoCuatro";
import { DiseñoFormCinco } from "./FormDiseñoCinco";

const coloresDisponibles = [
  "#1A425B",
  "#FFFFFF",
  "#00A69E",
  "#6A3090",
  "#FFA457",
];

const TipoProducto = [
  "FREE STANDING",
  "TABLE TOP",
  "ACCESORIOS",
  "TELEMETRÍA",
  "UNIDADES DE CONTROL",
  "MEDIDAS DE VASOS",
  "CASIA",
  "CASIA LOCKERS"
];

export const EditarProducto = ({ onclose, slider, fetchSliders }) => {

  const { Token } = useUserAdmin();
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  const [sliders, setSliders] = useState([]);
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [Categoria, setCategoria] = useState([]);
  const [alertMessage, setAlertMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    categoria_id: '',
    tipo_producto: '',
    color: "",
    cantidad: '',
    diseño: '',
    descripcion_tipo_producto: '',
    pdf: null,
    imagen_producto: null,
    logo_empresa_maquina: null,
    imagen_dispositivo: null,
    imagen_dispositivo1: null,
    imagen_dispositivo2: null,
    imagen_dispositivo3: null,
    imagen_dispositivo4: null,
    imagen_dispositivo5: null,
    imagen_dispositivo6: null,
    imagen_dispositivo7: null,
    logo_dispositivo: null,
    logo_dispositivo1: null,
    titulo_maquina: '',
    nombre_maquina: '',
    titulo_vision: '',
    descripcion_vision: '',
    texto_innovacion: '',
    caracteristica: '',
    caracteristica1: '',
    caracteristica2: '',
    caracteristica3: '',
    caracteristica4: '',
    caracteristica6: '',
    caracteristica7: '',
    caracteristica8: '',
    caracteristica9: '',
    caracteristica10: '',
    beneficio: '',
    beneficio1: '',
    beneficio2: '',
    beneficio3: '',
    beneficio4: '',
    beneficio5: '',
    beneficio6: '',
    capacidad: '',
    capacidad1: '',
    capacidad2: '',
    capacidad3: '',
    capacidad4: '',
    capacidad5: '',
    capacidad6: '',
    capacidad7: '',
    capacidad8: '',

  });

  useEffect(() => {
    const fetchCategoria = async () => {
      try {
        const response = await axios.get(`${backendURL}/api/all/producto/home`, {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        });
        setCategoria(response.data.data);
      } catch (error) {
        console.error("Error al obtener categorías:", error); // Corregido mensaje
      }
    };

    if (Token) {
      fetchCategoria();
    }
  }, [Token, backendURL]);

  useEffect(() => {
  const fetchProducto = async () => {
    if (!Token || !slider) return;

    try {
      const response = await axios.get(`${backendURL}/api/productos/especifico/${slider}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });

      const data = response.data.data;
      setSliders(data);

      // Desestructura las propiedades relevantes de `data` con valores por defecto
      setFormData({
        categoria_id: data.categoria_id || '',
        tipo_producto: data.tipo_producto || '',
        color: data.color || '',
        cantidad: data.cantidad || '',
        diseño: data.diseño || '',
        descripcion_tipo_producto: data.descripcion_tipo_producto || '',
        pdf: data.pdf || null,
        imagen_producto: data.imagen_producto || null,
        logo_empresa_maquina: data.logo_empresa_maquina || null,
        imagen_dispositivo: data.imagen_dispositivo || null,
        imagen_dispositivo1: data.imagen_dispositivo1 || null,
        imagen_dispositivo2: data.imagen_dispositivo2 || null,
        imagen_dispositivo3: data.imagen_dispositivo3 || null,
        imagen_dispositivo4: data.imagen_dispositivo4 || null,
        imagen_dispositivo5: data.imagen_dispositivo5 || null,
        imagen_dispositivo6: data.imagen_dispositivo6 || null,
        imagen_dispositivo7: data.imagen_dispositivo7 || null,
        logo_dispositivo: data.logo_dispositivo || null,
        logo_dispositivo1: data.logo_dispositivo1 || null,
        titulo_maquina: data.titulo_maquina || '',
        nombre_maquina: data.nombre_maquina || '',
        titulo_vision: data.titulo_vision || '',
        descripcion_vision: data.descripcion_vision || '',
        texto_innovacion: data.texto_innovacion || '',
        caracteristica: data.caracteristica || '',
        caracteristica1: data.caracteristica1 || '',
        caracteristica2: data.caracteristica2 || '',
        caracteristica3: data.caracteristica3 || '',
        caracteristica4: data.caracteristica4 || '',
        caracteristica6: data.caracteristica6 || '',
        caracteristica7: data.caracteristica7 || '',
        caracteristica8: data.caracteristica8 || '',
        caracteristica9: data.caracteristica9 || '',
        caracteristica10: data.caracteristica10 || '',
        beneficio: data.beneficio || '',
        beneficio1: data.beneficio1 || '',
        beneficio2: data.beneficio2 || '',
        beneficio3: data.beneficio3 || '',
        beneficio4: data.beneficio4 || '',
        beneficio5: data.beneficio5 || '',
        beneficio6: data.beneficio6 || '',
        capacidad: data.capacidad || '',
        capacidad1: data.capacidad1 || '',
        capacidad2: data.capacidad2 || '',
        capacidad3: data.capacidad3 || '',
        capacidad4: data.capacidad4 || '',
        capacidad5: data.capacidad5 || '',
        capacidad6: data.capacidad6 || '',
        capacidad7: data.capacidad7 || '',
        capacidad8: data.capacidad8 || '',
      });

    } catch (error) {
      console.error("Error al obtener producto:", error);
    }
  };

  fetchProducto();
}, [Token, slider, backendURL]);

  // Mostrar vista previa si ya existe una imagen
  const renderPreview = (file) => {
    if (!file) return null;
    const url = typeof file === "string"
      ? `${backendURL}/${file}` // <-- Agrega el dominio si es necesario
      : URL.createObjectURL(file);
    return <img src={url} alt="preview" style={{ width: "100%", marginBottom: 10 }} />;
  };
  // Manejo de archivos

  const handleFileChange = (e, campo) => {
    const file = e.target.files[0];
    setFormData(prev => ({ ...prev, [campo]: file }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  // Inicializar datos del slider seleccionado

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setEnviandoAlert(true);

    const data = new FormData();

    // Lista de campos que deben ser archivos (imágenes)
    const camposDeImagen = [
      'pdf',
      "imagen_producto",
      "logo_empresa_maquina",
      "imagen_dispositivo",
      "imagen_dispositivo1",
      "imagen_dispositivo2",
      "imagen_dispositivo3",
      "imagen_dispositivo4",
      "imagen_dispositivo5",
      "imagen_dispositivo6",
      "imagen_dispositivo7",
      "logo_dispositivo",
      "logo_dispositivo1",
    ];

    // Agrega los campos al FormData
    Object.entries(formData).forEach(([key, value]) => {
      if (camposDeImagen.includes(key)) {
        // Solo adjuntar si es un archivo nuevo (File)
        if (value instanceof File) {
          data.append(key, value);
        }
      } else {
        if (value !== null && value !== undefined && value !== '') {
          data.append(key, value);
        }
      }
    });


    try {
      await axios.post(`${backendURL}/api/editar/productos/${slider}`, data, {
        headers: {
          Authorization: `Bearer ${Token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      setAlertMessage("Slider actualizado correctamente.");
      setSuccessAlertOpen(true);

    } catch (error) {
      setAlertMessage("Error al actualizar el slider.");
      setErrorAlertOpen(true);
      console.error("Error al actualizar:", error);
    } finally {
      setLoading(false);
      setEnviandoAlert(false);
      await fetchSliders()
      setTimeout(() => {
        setSuccessAlertOpen(false);
        setEnviandoAlert(false)
        setErrorAlertOpen(false);
        onclose();

      }, 3000);
    }
  };
  return (
    <>
      {!sliders ? (
        <p>Cargando...</p>
      ) : sliders.diseño === "1" ? (
        <DiseñoFormUno
          Categoria={Categoria}
          handleInputChange={handleInputChange}
          formData={formData}
          coloresDisponibles={coloresDisponibles}
          TipoProducto={TipoProducto}
          setFormData={setFormData}
          handleFileChange={handleFileChange}
          renderPreview={renderPreview}
          handleSubmit={handleSubmit}
          loading={loading} />
      ) : sliders.diseño === "2" ? (
        <DiseñoFormDos
          Categoria={Categoria}
          handleInputChange={handleInputChange}
          formData={formData}
          coloresDisponibles={coloresDisponibles}
          TipoProducto={TipoProducto}
          setFormData={setFormData}
          handleFileChange={handleFileChange}
          renderPreview={renderPreview}
          handleSubmit={handleSubmit}
          loading={loading} />
      ) : sliders.diseño === "3" ? (
        <DiseñoFormTres
          Categoria={Categoria}
          handleInputChange={handleInputChange}
          formData={formData}
          coloresDisponibles={coloresDisponibles}
          TipoProducto={TipoProducto}
          setFormData={setFormData}
          handleFileChange={handleFileChange}
          renderPreview={renderPreview}
          handleSubmit={handleSubmit}
          loading={loading} />
      ) :
        sliders.diseño === "4" ? (
          <DiseñoFormCuatro
            Categoria={Categoria}
            handleInputChange={handleInputChange}
            formData={formData}
            coloresDisponibles={coloresDisponibles}
            TipoProducto={TipoProducto}
            setFormData={setFormData}
            handleFileChange={handleFileChange}
            renderPreview={renderPreview}
            handleSubmit={handleSubmit}
            loading={loading} />
        ) :
          sliders.diseño === "5" ? (
            <DiseñoFormCinco
              Categoria={Categoria}
              handleInputChange={handleInputChange}
              formData={formData}
              coloresDisponibles={coloresDisponibles}
              TipoProducto={TipoProducto}
              setFormData={setFormData}
              handleFileChange={handleFileChange}
              renderPreview={renderPreview}
              handleSubmit={handleSubmit}
              loading={loading} />
          ) : (
            <p>No hay formulario para este diseño</p>
          )}

      <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
            <IoClose style={{ color: '#585857' }} />
          </section>
          <section style={{ textAlign: 'center' }}>
            <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
            <p>{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      {/* Modal de error */}
      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: 'center' }}>
            <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
            <p>{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      {/* Modal de progreso */}
      <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: 'center', padding: '1rem' }}>
            <CircularProgress style={{ color: '#694B81' }} />
            <p>Procesando solicitud...</p>
          </section>
        </Box>
      </Modal>
    </>
  )
}

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: '#ffff',
  border: '0px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: '10px'
};
